import { Box, Grid, Stack, styled, Tab, Tabs, Typography } from '@mui/material';

import { StyledTabProps } from './modules/DetailAssemblyComponentList/DetailAssemblyComponentList.interface';

export const AssemblyDetailContainer = styled(Box)`
  display: flex;
  flex: 1;
  height: 100vh;
  flex-direction: row;
  padding: 0 !important;
`;

export const AssemblyDetailSideMenuContainer = styled(Box)(
  ({ theme }) => `
  position: relative;
  width: 23.125rem;
  overflow: auto;
  border-right: 1px solid ${theme.palette.secondary.light};
  height: 100%;
`,
);

export const BoxStyle = styled(Box)`
  padding: 1.25rem;
`;

export const AntTabs = styled(Tabs)(
  ({ theme }) => `
  border-Bottom: 0.0625rem solid ${theme.palette.primary.light};
  font-weight: 400;
  margin-Top: 0.9375rem;
  width: auto;
  & .MuiTabs-flexContainer {
    flex-direction: row;
    justify-content: space-evenly;
  }
  `,
);

export const AntTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(
  ({ theme }) => `
    text-transform: none;
    &:hover {
      color: ${theme.palette.primary.main};
    }
    &.Mui-selected {
      color: ${theme.palette.secondary.dark};
    },
    font-weight: 400;
    
   
  `,
);

export const AssemblyDetailContentContainer = styled(Box)`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  height: 100%;
`;

export const HeaderContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 30px 0 14px;
  align-items: flex-start;
`;

export const ActionButtonsContainer = styled(Stack)`
  flex-shrink: 0;
`;

export const AssemblyNameText = styled(Typography)`
  padding-right: 16px;
`;

export const SidebarContainer = styled(Box)`
  display: flex;
  position: relative;
  border-right: 1px solid black;
  width: 340px;
`;

export const GridContainer = styled(Grid)`
  align-items: center;
  direction: row;
  margin-top: 30px;
`;
